import { isEmpty } from 'lodash';

export function apiSuccessCheck(status) {
	if (!status) return false;
	return status >= 200 && status < 300;
}

export const noData = (value) => isEmpty(value) && !isPrimitive(value);

const isPrimitive = (value) =>
	isBoolean(value) || isString(value) || isNumber(value);

const isBoolean = (value) => typeof value === 'boolean';
const isString = (value) => typeof value === 'string';
const isNumber = (value) => typeof value === 'number';
